/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

import keyBy from 'lodash/fp/keyBy.js';
import { COMPONENT_POPULATION_METHOD_VALUES } from '@hbrisk/sp3-risk-model-support/models/app/attributes/values/index.js';

const { AUTOMATIC, CUSTOM } = COMPONENT_POPULATION_METHOD_VALUES;
const methods = [
  { id: AUTOMATIC, name: 'SP3 Automated' },
  { id: CUSTOM, name: 'User Defined' },
];

export const methodById = keyBy('id', methods);

export default methods;
